export { SHA256_HEX } from '@/lib/history-key/owner';
// Wire contract owned by third-party-gw-api/src/domains/t4/post-sale/website-verification-input.ts.
export const WEBSITE_CREDENTIAL = /^[A-Za-z0-9._~-]{1,8192}$/;
export const WEBSITE_SESSION_TIMEOUT_MS = 15_000;
export const WEBSITE_SESSION_TTL_SECONDS = 24 * 60 * 60;
export const WEBSITE_REJECTION_TTL_SECONDS = 30;
export const WEBSITE_REQUEST_LIMIT_BYTES = 1024 * 1024;
// Browsers cap persistent cookies at 400 days.
export const WEBSITE_BROWSER_TTL_SECONDS = 400 * 24 * 60 * 60;

// Wire contract: bazak-frontend/apps/assistant/lib/website-auth/constants.ts,
// bazak-mastra/src/mastra/common/website-auth.ts, third-party-gw-api/src/auth/website-headers.ts.
// The other two also carry `ANALYTICS_CALL_ID` and `ANALYTICS_IDENTITY_SOURCE`; those travel
// mastra → gateway only, and nothing here sets or reads them.
export const WEBSITE_HEADERS = {
  INTERNAL_AUTH: 'x-internal-auth',
  ORIGIN: 'x-bazak-website-origin',
  COOKIE_HASH: 'x-bazak-website-cookie-hash',
  SCOPE: 'x-bazak-website-scope',
  ANALYTICS_DISTINCT_ID: 'x-bazak-analytics-distinct-id',
  ANALYTICS_SESSION_ID: 'x-bazak-analytics-session-id',
  PREFIX: 'x-bazak-website-',
} as const;

// website_session_invalid flows Mastra → frontend; invalid_service_credential flows gateway → Mastra.
export const WEBSITE_ERROR = {
  NOT_FOUND: 'not_found',
  ORIGIN_DENIED: 'origin_denied',
  WEBSITE_SESSION_REQUIRED: 'website_session_required',
  WEBSITE_SESSION_EXPIRED: 'website_session_expired',
  WEBSITE_SESSION_INVALID: 'website_session_invalid',
  WEBSITE_SESSION_UNAVAILABLE: 'website_session_unavailable',
  INVALID_REQUEST: 'invalid_request',
  REQUEST_TOO_LARGE: 'request_too_large',
  BROWSER_SESSION_REQUIRED: 'browser_session_required',
} as const;
export type WebsiteErrorCode = (typeof WEBSITE_ERROR)[keyof typeof WEBSITE_ERROR];
